import { CardActions as MuiCardActions } from '@mui/material';
import { styled } from '@mui/system';

const CardActions = styled(MuiCardActions)({
  padding: '10px 15px 15px',
});

export default CardActions;
